import request from '@/utils/request'

export function batchUpdateStatus() {
  return request({
    url: '/order/refund/batchUpdateStatus',
    method: 'get'
  })
}

// 查询退货订单列表
export function listRefund(query) {
  return request({
    url: '/order/refund/list',
    method: 'get',
    params: query
  })
}

// 查询退货订单分页
export function pageRefund(query) {
  return request({
    url: '/order/refund/page',
    method: 'get',
    params: query
  })
}

// 查询退货订单详细
export function getRefund(data) {
  return request({
    url: '/order/refund/detail',
    method: 'get',
    params: data
  })
}

// 新增退货订单
export function auditRefund(data) {
  return request({
    url: '/order/refund/audit',
    method: 'post',
    data: data
  })
}

export function auditRefundBatch(data) {
  return request({
    url: '/order/refund/audit/batch',
    method: 'post',
    data: data
  })
}

// 修改退货订单
export function updateRefund(data) {
  return request({
    url: '/order/refund/edit',
    method: 'post',
    data: data
  })
}

// 删除退货订单
export function delRefund(data) {
  return request({
    url: '/order/refund/delete',
    method: 'post',
    data: data
  })
}

// 删除退货订单
export function getExamineByZt(data) {
  return request({
    url: '/order/refund/getExamineByZt',
    method: 'post',
    data: data
  })
}
